import SingleFooter from './SingleFooter'


export default SingleFooter;